import React from "react";

/**
 * O mascote falando, com o texto digitado caractere a caractere.
 *
 * Saiu de dentro de `CerimoniaCard.jsx` em 05/08/2026, quando o encerramento
 * também passou a ter o mascote falando — mesmo argumento que tirou
 * `textoDigitado.js` de `IntroMascote` em 03/08: um componente compartilhado não
 * pertence a uma tela, e importar a cerimônia inteira só para pegar a bolha
 * amarraria o encerramento a ela sem nenhuma razão.
 *
 * APRESENTAÇÃO PURA: o hook de digitação fica em quem USA, não aqui. Na cerimônia
 * porque o painel precisa poder COMPLETAR a fala no primeiro toque; no encerramento
 * pelo mesmo motivo, com o botão de pular. Passar `digitado` de fora é o que mantém
 * uma fonte de verdade só.
 *
 * @param {object}   mascote   { nome, cabeca, corpo }
 * @param {string}   texto     a fala inteira (o "fantasma" e o leitor de tela)
 * @param {string}   digitado  o pedaço já revelado
 * @param {boolean}  digitando se ainda falta texto (liga o cursor)
 * @param {string}   [figura]  a arte a usar; por padrão a CABEÇA, que é o
 *                             enquadramento pensado para os slots pequenos. O
 *                             encerramento passa o corpo inteiro, porque ali o
 *                             mascote é a figura principal da tela.
 */
function FalaDoMascote({ mascote, texto, digitado, digitando, figura }) {
  return (
    <div className="trilha-ludica__fala">
      {mascote && (
        <img
          className="trilha-ludica__fala-mascote tl-anim-float"
          src={figura || mascote.cabeca}
          alt={mascote.nome}
        />
      )}
      <p className="trilha-ludica__pilula">
        {/* TRÊS CAMADAS, e cada uma resolve um problema diferente.

            1. FANTASMA: o texto completo, invisível, reservando a altura final
               desde o primeiro quadro. Sem ele a bolha cresce a cada caractere e
               empurra o que estiver abaixo — na cerimônia em paisagem, a bolha é
               item de um grid cujas faixas se dimensionam pelo conteúdo, então o
               bloco de texto inteiro escorrega sob os olhos de quem lê.

            2. CÓPIA VISÍVEL: o que a criança vê sendo digitado. Leva
               `aria-hidden` porque muda 60 vezes durante a fala, e sem isso a
               leitura vira uma enxurrada de anúncios.

            3. SÓ-LEITOR: o texto completo, uma vez, para quem usa leitor de tela.
               ESTA CAMADA É NOVA (05/08/2026) e conserta um defeito real: o
               comentário que vivia aqui afirmava que "é o fantasma que o leitor
               de tela lê", mas `.trilha-ludica__pilula-fantasma` é
               `visibility: hidden`, o que o tira da árvore de acessibilidade. Com
               a cópia visível em `aria-hidden`, a fala do mascote na cerimônia
               não era anunciada a NINGUÉM. Na abertura o arranjo é o inverso (o
               `aria-hidden` está no fantasma) e por isso lá funcionava. */}
        <span className="trilha-ludica__so-leitor">{texto}</span>
        <span className="trilha-ludica__pilula-fala" aria-hidden="true">
          <span className="trilha-ludica__pilula-fantasma">{texto}</span>
          <span
            className={`trilha-ludica__pilula-visivel${
              digitando ? " trilha-ludica__pilula-visivel--digitando" : ""
            }`}
          >
            {digitado}
          </span>
        </span>
      </p>
    </div>
  );
}

export default FalaDoMascote;
